import React from "react";

const QuestionsList = ({ questions }) => {
  return (
    <div className="space-y-1">
      {questions.map((question, index) => (
        <div
          key={question._id}
          className="p-2 bg-white  border border-l-2 rounded-md shadow-inner border-l-gray-200 border-gray-100"
        >
          <h2 className="">
            {index + 1}. {question.question}
          </h2>
        </div>
      ))}
    </div>
  );
};

export default QuestionsList;
